import Vue from "vue";
import {loginPath} from "../assets/js/common";

export class sandboxRequest {


    /**
     * callback 返回参数 open: true/false
     * @param callback
     */
    static showSandboxEnv() {
        return new Promise((resolve, reject) => {
            Vue.prototype.$axios.get('/ajax/developer/env/open').then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }

    static checkMobile(mobile) {
        const checkMobileURI = '/ajax/developer/check/mobile';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.get(checkMobileURI, {
                params: {
                    reg_mobile: mobile
                }
            }).then(res => {
                resolve(res.data);
            }).catch(e => {
                reject(e);
            })
        })
    }

    static checkEmail(mobile, email) {
        const checkEmailURI = '/ajax/developer/check/email';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.get(checkEmailURI, {
                params: {
                    reg_mobile: mobile,
                    email: email,
                }
            }).then(res => {
                resolve(res.data);
            }).catch(e => {
                reject(e);
            })
        });
    }

    static checkAccount(mobile, account) {
        const checkAccountURI = '/ajax/developer/check/account';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.get(checkAccountURI, {
                params: {
                    reg_mobile: mobile,
                    account: account,
                }
            }).then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }

    /**
     * 提交注册
     * @param form: {
     *     account     用户名
           reg_mobile  手机号
           email       邮箱
           password	   密码
           password_confirmation   确认密码
           email_code   邮箱验证码
           code 图形验证码
           key	图形验证码唯一标识
     * }
     * @returns {Promise}
     */
    static submitRegister(form) {
        const register = '/ajax/developer/register';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.post(register, form).then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }

    /**
     * 绑定账号
     * @param form: {
     *     reg_mobile	手机号
           sms_code	短信验证码
           code	 图形验证码
           key	 图形验证码唯一标识
     * }
     * @returns {Promise}
     */
    static bind(form) {
        const bindURI = '/ajax/developer/bind';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.post(bindURI, form).then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }

    /**
     * 账号密码登录
     * @param form: {
     *     account	账户名
           password	密码
           code	 图形验证码
           key	 图形验证码唯一标识
     * }
     * @returns {Promise}
     */
    static loginByPwd(form) {
        const loginByAccount = '/ajax/developer/login/account';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.post(loginByAccount, form).then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }

    /**
     * 绑定沙箱账号 - 密码模式
     * @param form 同账号登录
     * @returns {Promise<unknown>}
     */
    static bindByPwd(form) {
        const bindURI = '/ajax/developer/bind/account';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.post(bindURI, form).then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }

    /**
     * 验证码登录
     * @param form: {
     *     reg_mobile	手机号
           sms_code	短信验证码
           code	 图形验证码
           key	 图形验证码唯一标识
     * }
     * @returns {Promise}
     */
    static loginByCode(form) {
        const loginByCode = '/ajax/developer/login/mobile';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.post(loginByCode, form).then(res => {
                console.log('请求成功' + res)
                resolve(res.data);
            }).catch(ex => {
                console.log('请求失败' + ex);
                reject(ex);
            })
        })
    }

    /**
     * 绑定沙箱账号 - 验证码模式
     * @param form
     * @returns {Promise<unknown>}
     */
    static bindByCode(form) {
        const bindURI = '/ajax/developer/bind/mobile';
        return new Promise((resolve, reject) => {
            if (this.isLoading) {
                return;
            }
            Vue.prototype.$axios.post(bindURI, form).then(res => {
                resolve(res.data);
            }).catch(ex => {
                reject(ex);
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/axios/sandboxRequest.js